export const HIGHLIGHT_OPTIONS = [
  { name: 'Bounce Left', value: 'bounce-right' },
  { name: 'Bounce Right', value: 'bounce-left' },
  { name: 'Grow', value: 'grow' },
  { name: 'Rubberband', value: 'rubberband' },
  { name: 'Shake', value: 'shake' },
  { name: 'Slide Left', value: 'slide-right' },
  { name: 'Slide Right', value: 'slide-left' },
];
